import type {ComponentProps} from 'react';

import {StripeAssistant} from '@stripe-internal/conversations-assistant';

import {DotComAssistantInput} from './components/DotComAssistantInput';
import {DotComAssistantLog} from './components/DotComAssistantLog';
import {DotComHeader} from './components/DotComHeader/DotComHeader';
import {SalesProvider} from './SalesProvider';

type DotComVisualOverride =
  | 'footer'
  | 'header'
  | 'input'
  | 'log'
  | 'showWave'
  | 'subheader';

type StripeAssistantProps = ComponentProps<typeof StripeAssistant>;

export type DotComAssistantProps = Omit<
  StripeAssistantProps,
  DotComVisualOverride
> & {
  config: NonNullable<StripeAssistantProps['config']>;
  profile: NonNullable<StripeAssistantProps['profile']>;
};

function DotComAssistantHeader() {
  // 2026-03-30 WPP has decided to disable sales chat CSAT for now
  // at the highest level possible, to keep the underlying functionality
  // intact in case CSAT is desired again in the near future.
  return <DotComHeader isCSAT={false} />;
}

export function DotComAssistant(props: DotComAssistantProps) {
  return (
    <SalesProvider>
      <StripeAssistant
        {...props}
        // TODO(dot_com parity): footer={null} and showWave={false} are
        // inferred from the legacy Widget — confirm against production
        // stripe.com. Known gap: legacy collapses the pane when minimized
        // (height 0 / visibility hidden), which also removes the clipped
        // controls from the tab order; not ported yet.
        footer={null}
        header={DotComAssistantHeader}
        input={DotComAssistantInput}
        log={DotComAssistantLog}
        showWave={false}
        subheader={null}
      />
    </SalesProvider>
  );
}
